/* XO Cases: shared phone-model data + helpers (window.XOModels).
   Model lists are read from the product page's own brand/model picker,
   so they always stay in sync with what customers can actually order. */
(function () {
  if (window.XOModels) return;

  var CACHE_KEY = 'xoModelsV1';
  var SAVE_KEY = 'xoPhone';
  var SOURCE_PAGE = '/products/burgundy-kisses-phone-case';
  var CASE_TYPES = ['Premium Glass Case', 'Black Silicone', 'Clear Silicone', 'Sticker'];
  var BRANDS = ['Apple', 'Samsung', 'OnePlus', 'Vivo', 'Oppo', 'Realme', 'Xiaomi', 'Nothing', 'IQOO', 'Motorola', 'Google'];
  var LABELS = { Xiaomi: 'Xiaomi / Redmi / Poco', IQOO: 'iQOO' };

  var GLOSSY = {
    Apple: [
      'Apple Iphone 18 Pro Max', 'Apple Iphone 18 Pro', 'Apple Iphone 18',
      'Apple Iphone 17 Pro Max', 'Apple Iphone 17 Pro', 'Apple Iphone 17 Air', 'Apple Iphone 17', 'Apple Iphone Air',
      'Apple Iphone 16 Pro Max', 'Apple Iphone 16 Pro', 'Apple Iphone 16 Plus', 'Apple Iphone 16', 'Apple Iphone 16 E',
      'Apple Iphone 15 Pro Max', 'Apple Iphone 15 Pro', 'Apple Iphone 15 Plus', 'Apple Iphone 15',
      'Apple Iphone 14 Pro Max', 'Apple Iphone 14 Pro', 'Apple Iphone 14 Plus', 'Apple Iphone 14',
      'Apple Iphone 13 Pro Max', 'Apple Iphone 13 Pro', 'Apple Iphone 13 Mini', 'Apple Iphone 13',
      'Apple Iphone 12 Pro Max', 'Apple Iphone 12 Pro', 'Apple Iphone 12 Mini', 'Apple Iphone 12',
      'Apple Iphone 11 Pro Max', 'Apple Iphone 11 Pro', 'Apple Iphone 11'
    ],
    Google: [
      'Google Pixel 10 Pro XL', 'Google Pixel 10 Pro', 'Google Pixel 10',
      'Google Pixel 9 Pro XL', 'Google Pixel 9 Pro', 'Google Pixel 9', 'Google Pixel 9a',
      'Google Pixel 8 Pro', 'Google Pixel 8', 'Google Pixel 8a',
      'Google Pixel 7 Pro', 'Google Pixel 7', 'Google Pixel 7a'
    ],
    Samsung: [
      'Samsung Galaxy S26 Ultra', 'Samsung Galaxy S26 Plus', 'Samsung Galaxy S26',
      'Samsung Galaxy S25 Ultra', 'Samsung Galaxy S25 Plus', 'Samsung Galaxy S25',
      'Samsung Galaxy S24 Ultra', 'Samsung Galaxy S24 Plus', 'Samsung Galaxy S24',
      'Samsung Galaxy S23 Ultra', 'Samsung Galaxy S23 Plus', 'Samsung Galaxy S23'
    ]
  };

  // Words that don't help identify a model ("samsung galaxy s24 ultra 5g case" -> "s24ultra")
  var NOISE = ['apple', 'samsung', 'galaxy', 'google', 'xiaomi', 'motorola', 'vivo', '5g', '4g', 'international',
    'case', 'cases', 'cover', 'covers', 'back', 'phone', 'mobile', 'for', 'the', 'new'];

  function key(s) {
    s = String(s || '').toLowerCase().replace(/\+/g, ' plus ').replace(/[^a-z0-9 ]/g, ' ');
    return s.split(/\s+/).filter(function (t) { return t && NOISE.indexOf(t) < 0; }).join('');
  }

  var FIX = { iphone: 'iPhone', iqoo: 'iQOO', xl: 'XL', se: 'SE', fe: 'FE', gt: 'GT', cmf: 'CMF', ne: 'NE' };
  function pretty(s) {
    s = String(s || '').replace(/\s+/g, ' ').trim();
    if (/[A-Z]/.test(s)) return s.replace(/Iphone/g, 'iPhone');
    return s.split(' ').map(function (w) {
      if (FIX[w]) return FIX[w];
      if (/^\d+g$/.test(w)) return w.toUpperCase();
      return w.charAt(0).toUpperCase() + w.slice(1);
    }).join(' ');
  }

  function build(raw) {
    var out = {};
    BRANDS.forEach(function (b) {
      var seen = {}, list = [];
      var src = raw[b] || {};
      CASE_TYPES.forEach(function (t) {
        (src[t] || []).forEach(function (m) {
          var k = key(m);
          if (!k || seen[k] !== undefined) {
            // prefer the nicely-capitalised spelling if we see it later
            if (k && /[A-Z]/.test(m) && !/[A-Z]/.test(list[seen[k]])) list[seen[k]] = pretty(m);
            return;
          }
          seen[k] = list.length;
          list.push(pretty(m));
        });
      });
      // newest-first, natural order (iPhone 16 Pro Max, 16 Pro, 16, 15 ...)
      list.sort(function (a, c) { return key(c).localeCompare(key(a), 'en', { numeric: true }); });
      if (list.length) out[b] = list;
    });
    return out;
  }

  function parse(html) {
    var m = html.match(/const phoneModels\s*=\s*(\{[\s\S]*?\});\s*\/\/\s*Get elements/);
    if (!m) throw new Error('model list not found');
    return build(new Function('return ' + m[1])());
  }

  var pending = null;
  function load() {
    if (pending) return pending;
    try {
      var c = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (c && c.t > Date.now() - 3 * 864e5 && c.d) { pending = Promise.resolve(c.d); return pending; }
    } catch (e) {}
    pending = fetch(SOURCE_PAGE, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var d = parse(html);
        try { localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
        return d;
      })
      .catch(function (e) { pending = null; throw e; });
    return pending;
  }

  function find(query, data) {
    var q = key(query);
    if (q.length < 2 || !/\d/.test(q) || !/[a-z]/.test(q)) return null;
    var best = null;
    BRANDS.forEach(function (b) {
      (data[b] || []).forEach(function (m) {
        var k = key(m);
        if (k === q) { if (!best || best.exact !== true) best = { brand: b, model: m, exact: true, len: k.length }; }
        else if (!best || !best.exact) {
          if (k.indexOf(q) > -1 && (!best || k.length < best.len)) best = { brand: b, model: m, exact: false, len: k.length };
        }
      });
    });
    return best ? { brand: best.brand, model: best.model } : null;
  }

  function hasGlossy(brand, model) {
    var k = key(model);
    return (GLOSSY[brand] || []).some(function (m) { return key(m) === k; });
  }

  function url(brand, model, collection) {
    return '/collections/' + (collection || 'phone-cases') + '?phone=' + encodeURIComponent(brand + '|' + model);
  }

  function save(brand, model) {
    try { localStorage.setItem(SAVE_KEY, JSON.stringify({ brand: brand, model: model })); } catch (e) {}
  }
  function saved() {
    try { return JSON.parse(localStorage.getItem(SAVE_KEY) || 'null'); } catch (e) { return null; }
  }
  function fromUrl() {
    try {
      var p = new URLSearchParams(location.search).get('phone');
      if (!p || p.indexOf('|') < 0) return null;
      var parts = p.split('|');
      return { brand: parts[0], model: parts.slice(1).join('|') };
    } catch (e) { return null; }
  }

  window.XOModels = {
    BRANDS: BRANDS,
    label: function (b) { return LABELS[b] || b; },
    load: load, find: find, key: key, hasGlossy: hasGlossy,
    url: url, save: save, saved: saved, fromUrl: fromUrl,
    _parse: parse
  };
})();
